import * as React from 'react';
import isNumber from 'lodash/isNumber';

import PageHeading from 'components/page/page-heading/PageHeading';

import { __t, applyTranslations } from 'utils/language';
import { renderPrice } from 'utils/helper/price';

import './ccm-offer-banner.scss';

applyTranslations(require('./ccm-offer-banner.i18n.json'));

import {
  Campaign
} from 'types';

type Props = {
  campaign: Campaign,
  affiliationPerClickCost: string
};

const MSG_KEY = 'ccm_offer_banner';

const CcmOfferBanner: React.FC<Props> = ({
  campaign,
  affiliationPerClickCost
}): JSX.Element => {
  const productionBudget = isNumber(campaign.contentProductionBudget) ? campaign.contentProductionBudget : 0;
  const outfitsPerCreator = campaign.outfitsPerCreator ?? 0;
  const totalBudget = productionBudget * outfitsPerCreator;

  return (
    <div className="ccm-offer-banner">
      <PageHeading
        heading={__t(`${MSG_KEY}.title`)}
        size="h3"
        margin="none"
        weight="bold"
      />
      <div className="ccm-offer-banner__contents">
        <div
          className="ccm-offer-banner__primary-text"
          title={__t(`${MSG_KEY}.heading`)}
        >
          {__t(`${MSG_KEY}.heading`)}
        </div>
        <div className="ccm-offer-banner__values">
          <div className="offer-banner-details__budget">
            {__t(`${MSG_KEY}.labels.budget_offer`)}:&nbsp;
            {renderPrice(totalBudget)}
          </div>
          <div className="offer-banner-details__affiliation">
            {__t(`${MSG_KEY}.labels.outfit_affiliation`)}:&nbsp;
            {__t(`${MSG_KEY}.messages.affiliation_description_text`, {
              price: renderPrice(Number(affiliationPerClickCost) ?? 0)
            })}
          </div>
        </div>
        <div className="ccm-offer-banner__messages">
          <div>
            <span>{__t(`${MSG_KEY}.labels.budget_description`)}</span>:&nbsp;
            {__t(`${MSG_KEY}.messages.budget_description`)}
          </div>
          <div>
            <span>{__t(`${MSG_KEY}.labels.affiliation_description`)}</span>:&nbsp;
            {__t(`${MSG_KEY}.messages.affiliation_description`, {
              price: renderPrice(Number(affiliationPerClickCost) ?? 0)
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CcmOfferBanner;
